import { render, staticRenderFns } from "./team_list.vue?vue&type=template&id=482b628f&scoped=true"
import script from "./team_list.vue?vue&type=script&lang=js"
export * from "./team_list.vue?vue&type=script&lang=js"
import style0 from "./team_list.vue?vue&type=style&index=0&id=482b628f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482b628f",
  null
  
)

export default component.exports